import editParameterForm from './editParameterFormModel';
const {
  formField: {
    // DATOS PARAMETROS 
    e_llegadas_tarde,
    e_salidas_tarde,
    e_salario_minimo,
    e_auxilio_transporte,
    e_interes_cesantias,
    e_year
  } 
} = editParameterForm;

export default {
  [e_llegadas_tarde.name]: '',
  [e_salidas_tarde.name]: '',
  [e_salario_minimo.name]: '',
  [e_auxilio_transporte.name]: '',
  [e_interes_cesantias.name]: '',
  [e_year.name]: '',
};

